import PlanningReviewConfirmRemoveReviewModal from './planning-review-confirm-remove-review-modal'

export default PlanningReviewConfirmRemoveReviewModal
